// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"231":"81171a0c15bba2e8d01c","589":"0e20a1ba735509de4df4","610":"104f693cf142e6460edb","678":"e25f7b8ed73ba735f359","711":"763d169ffc2c8e8a5f7b","883":"4c8c9e488a419083d7a6"}[chunkId] + ".js";
};